module.exports = __webpack_public_path__ + "static/media/big-alves.6817c726.jpg";